import firebase from "firebase";
import api from "../../../services/api";
import axios from "axios";
import ImageUploader from "vue-image-upload-resize";
// import { mapState } from 'vuex'

export default {
  props: ["emp"],

  components: {
    ImageUploader,
  },

  data() {
    return {
      dadosEmpresa: null,
      bgColor: "#a1a1a1",

      blocos: [],

      documentacao: [],
      logo: "",
      listaImgRg: [], // monta html
      listaCarteiraConselho: [], // monta html
      listaInscricaoPis: [], // monta html
      listaTituloEleitor: [], // monta html
      listaCCM: [], // monta html
      listaEndereco: [], // monta html
      listaDadosBancarios: [], // monta html
      listaDependentes: [], // monta html
      listaNegativaConselho: [], // monta html
      listaDiploma: [], // monta html
      listaVacinacao: [], // monta html
      listaCurriculo: [], // monta html
      listaCriminais: [], // monta html
      listaAssinaturaCarimboCOREN: [], // monta html
      listaBlocoVariavel_1500: [], // monta html
      listaBlocoVariavel_1510: [], // monta html
      listaBlocoVariavel_1520: [], // monta html
      listaBlocoVariavel_1530: [], // monta html
      listaBlocoVariavel_1540: [], // monta html

      nomeFoto: [],
      fotoPerfil: null,
      uploadValue1: null,
      botaoVisivel: true,

      enderecoEdit: true,

      estadoCivil: [
        "SOLTEIRO(A)",
        "CASADO(A)",
        "DIVORCIADO(A)",
        "SEPARADO(A)",
        "VIÚVO(A)",
      ],

      racas: [
        "BRANCA",
        "PRETA",
        "PARDA",
        "AMARELA",
        "INDÍGENA",
        "NÃO INFORMADO",
      ],

      sexo: ["MASCULINO", "FEMININO"],
      fumante: ["SIM", "NÃO"],

      labelDadosAdicionais: "",

      escolaridades: [],
      paises: [],
      bancos: [],

      listaConhecimentosTecnicos: [],

      tipoContas: [{ value: null, text: "" }, "CORRENTE", "POUPANÇA"],

      //   dispPlantoes: [],
      listaPlantoes: [
        { text: "Diurno Impar", value: "diaImpar" },
        { text: "Diurno Par", value: "diaPar" },
        { text: "Noturno Impar", value: "noiteImpar" },
        { text: "Noturno Par", value: "noitePar" },
      ],

      //   selProcedimentos: [],
      listaProcedimentos: [
        { text: "Manhã", value: "manha" },
        { text: "Tarde", value: "tarde" },
        { text: "Noite", value: "noite" },
      ],

      tiposDependentes: [],
      dependente: {
        nome: null,
        cpf: null,
        dataNasc: null,
        tipo: null,
      },
      editarDep: false,
      editarIndex: 0,

      fields: [
        { key: "nome", label: "Nome" },
        { key: "cpf", label: "CPF" },
        {
          key: "dataNasc",
          label: "Data Nascimento",
          formatter: (value) => {
            const dataView = value.split("-");
            return `${dataView[2]}/${dataView[1]}/${dataView[0]}`;
          },
        },
        {
          key: "tipo",
          label: "Tipo dependente",
          formatter: (value) => {
            const valor = this.tiposDependentes.filter(
              (item) => item.value == value
            )[0].text;
            return valor.length > 27 ? valor.substring(0, 28) + "..." : valor;
          },
        },
        { key: "actions", label: "Ações" },
      ],

      form: {
        nome: "",
        email: "",
        cpf: "",
        estadoCivil: "",
        nacionalidade: "",
        escolaridade: "",
        raca: "",
        dataNasc: "",
        sexo: "",
        restFisica: "",
        fumante: "",
        dadosAdic: "",
        rg: "",
        rgOrgaoEmissor: "",
        rgDataExp: "",
        nomeFuncao: "",
        regProf: "",
        regNum: "",
        regDataVencimento: "",
        pis: "",
        tituloEleitor: "",
        ccm: "",
        cep: "",
        cidade: "",
        uf: "",
        bairro: "",
        endereco: "",
        numEndereco: "",
        complemento: "",
        celular: "",
        celAdic: "",
        fixo: "",
        banco: "",
        agencia: "",
        conta: "",
        contaDig: "",
        tipoConta: "",
        chavePix: "",
        nomeBeneficiario: "",
        cpfBeneficiario: "",
        nomeBeneficiarioObito: "",
        tipoBeneficiarioObito: null,
        tipoBeneficiarioOutroTexto: "",
        file1: "",
        dependentes: [],
        urlFotoPerfil: null,
        urlRg: [],
        urlCarteiraConselho: [],
        urlInscricaoPis: [],
        urlTituloEleitor: [],
        urlCCM: [],
        urlEndereco: [],
        urlDadosBancarios: [],
        urlDependentes: [],
        urlNegativaConselho: [],
        urlDiploma: [],
        urlVacinacao: [],
        urlCurriculo: [],
        urlAntCriminais: [],
        urlAssinaturaCarimboCoren: [],
        dadosBlocoVariavel_1000: null,
        dadosBlocoVariavel_1010: null,
        dadosBlocoVariavel_1020: null,
        dadosBlocoVariavel_1030: null,
        dadosBlocoVariavel_1040: null,
        urlBlocoVariavel_1500: [],
        urlBlocoVariavel_1510: [],
        urlBlocoVariavel_1520: [],
        urlBlocoVariavel_1530: [],
        urlBlocoVariavel_1540: [],
        nomeMae: "",
        nomePai: "",
        nomeConjuge: "",
        cidadeNascimento: "",
        ufNascimento: "",
      },

      show: true,
      img1: false,
      img2: false,

      ref: null,
      ufs: [],
      municipios: [],
      municipiosPorUF: [],

      avaliacao: {
        rating: "",
        comentario: "",
      },

      limiteDeTamanhoArquivos: null,
      apiTimeout: null

    };
  },

 
  async created() {
    try {
      await this.getMunicipiosEUFs();
    } catch (error) {
      console.error('[DOCUMENTACAO] ✗ getMunicipiosEUFs FALHOU:', error);
    }

    try {
      await this.getSolicitacao();
    } catch (error) {
      console.error('[DOCUMENTACAO] ✗ getSolicitacao FALHOU:', error);
    }

    try {
      await this.getDadosEmpresa();
    } catch (error) {
      console.error('[DOCUMENTACAO] ✗ getDadosEmpresa FALHOU:', error);
    }

    try {
      await this.getBlocosReprovados();
    } catch (error) {
      console.error('[DOCUMENTACAO] ✗ getBlocosReprovados FALHOU:', error);
    }

    this.carregarMunicipios();
    this.logarFirebase();
    this.limiteDeTamanhoArquivos = Number(process.env.VUE_APP_FILE_SIZE_LIMIT);

    this.$watch('form', () => {
      clearTimeout(this.apiTimeout);

      this.apiTimeout = setTimeout(() => {
        this.salvar('salvar')

      }, 3000)

    }, { deep: true });

  },

  mounted() {
    // Remove máscara indesejada do campo de beneficiário com MutationObserver
    this.$nextTick(() => {
      const el = this.$refs.inputBeneficiarioObito; // Input nativo, não tem $el
      if (el) {
        // Função para remover atributos de máscara
        const removeMask = () => {
          el.removeAttribute('data-mask');
          el.removeAttribute('data-mask-inited');
          el.removeAttribute('data-mask-raw-value');
        };

        // Remove imediatamente
        removeMask();

        // Observa mudanças nos atributos e remove máscara continuamente
        const observer = new MutationObserver(() => {
          if (el.hasAttribute('data-mask')) {
            removeMask();
          }
        });

        observer.observe(el, {
          attributes: true,
          attributeFilter: ['data-mask', 'data-mask-inited', 'data-mask-raw-value']
        });

        // Limpa observer quando componente for destruído
        this.$once('hook:beforeDestroy', () => {
          observer.disconnect();
        });
      }
    });
  },

  methods: {
    // Preenche o campo de texto com o nome do parentesco selecionado
    // Se for "OUTROS" (99), limpa para o usuário digitar manualmente
    onTipoBeneficiarioObitoChange(valor) {
      if (valor == 99) {
        this.form.tipoBeneficiarioOutroTexto = '';
      } else if (valor) {
        const tipoSelecionado = this.tiposDependentes.find(t => t.value == valor);
        this.form.tipoBeneficiarioOutroTexto = tipoSelecionado?.text?.toUpperCase() || '';
      } else {
        this.form.tipoBeneficiarioOutroTexto = '';
      }
    },

    async logarFirebase() {
      let userFirebase = this.$store.state.firebaseAuth.user;
      await firebase
        .auth()
        .signInWithEmailAndPassword(userFirebase.login, userFirebase.pass);
      userFirebase = null;
    },

    async deslogarFirebase() {
      await firebase.auth().signOut();
    },

    msg(titulo, texto, cor, time = 10000) {
      this.toastCount++;
      this.$bvToast.toast(texto, {
        title: titulo,
        variant: cor,
        solid: true,
        autoHideDelay: time,
        appendToast: true,
      });
    },

    
    blocoVisivel(codBloco, contemImagem) {
      let visivel = false;

      if (contemImagem == "sim") {
        this.blocos.forEach((item) => {
          if (
            item.cod == codBloco &&
            item.visivel == "sim" &&
            item.imagem == contemImagem
          )
            visivel = true;
        });
      } else if (contemImagem == "não") {
        this.blocos.forEach((item) => {
          if (
            item.cod == codBloco &&
            item.visivel == "sim" &&
            item.imagem != "sim"
          )
            visivel = true;
        });
      } else {
        this.blocos.forEach((item) => {
          if (item.cod == codBloco && item.visivel == "sim") visivel = true;
        });
      }

      return visivel;
    },

    blocoObrigatorio(codBloco) {
      let obrigatorio = false;
      this.blocos.forEach((item) => {
        if (item.cod == codBloco && item.obrigatorio == "sim")
          obrigatorio = true;
      });

      return obrigatorio;
    },

    textoTitulo(codBloco, contemImagem) {
      let texto = "";

      if (contemImagem == "sim") {
        this.blocos.forEach((item) => {
          if (item.cod == codBloco && item.imagem == contemImagem)
            texto = item.titulo;
        });
      } else if (contemImagem == "não") {
        this.blocos.forEach((item) => {
          if (item.cod == codBloco && item.imagem != "sim") texto = item.titulo;
        });
      } else {
        // Quando não especifica, prioriza bloco sem imagem (formulário)
        // Se não existir versão sem imagem, usa a versão com imagem
        const blocoSemImagem = this.blocos.find(
          item => item.cod == codBloco && item.imagem != "sim"
        );
        const blocoComImagem = this.blocos.find(
          item => item.cod == codBloco && item.imagem == "sim"
        );
        texto = blocoSemImagem ? blocoSemImagem.titulo : (blocoComImagem ? blocoComImagem.titulo : "");
      }

      return texto;
    },

    textoBloco(codBloco, contemImagem) {
      let texto = "";

      if (contemImagem == "sim") {
        this.blocos.forEach((item) => {
          if (item.cod == codBloco && item.imagem == contemImagem)
            texto = item.instrucoes;
        });
      } else if (contemImagem == "não") {
        this.blocos.forEach((item) => {
          if (item.cod == codBloco && item.imagem != "sim")
            texto = item.instrucoes;
        });
      } else {
        // Quando não especifica, prioriza bloco sem imagem (formulário)
        // Se não existir versão sem imagem, usa a versão com imagem
        const blocoSemImagem = this.blocos.find(
          item => item.cod == codBloco && item.imagem != "sim"
        );
        const blocoComImagem = this.blocos.find(
          item => item.cod == codBloco && item.imagem == "sim"
        );
        texto = blocoSemImagem ? blocoSemImagem.instrucoes : (blocoComImagem ? blocoComImagem.instrucoes : "");
      }

      return texto;
    },

    textoBlocoMotivoRep(codBloco, contemImagem) {
      let texto = "";

      if (contemImagem == "sim") {
        this.blocos.forEach((item) => {
          if (item.cod == codBloco && item.imagem == contemImagem)
            texto = item.motivo;
        });
      } else if (contemImagem == "não") {
        this.blocos.forEach((item) => {
          if (item.cod == codBloco && item.imagem != "sim")
            texto = item.motivo;
        });
      } else {
        this.blocos.forEach((item) => {
          if (item.cod == codBloco) texto = item.motivo;
        });
      }

      return texto;
    },

    selecionarImagem(base64, listaImg, idTarget, codBloco, listaImgNome) {
      this.hasImage = true;
      this.image = base64;

      // Verifica se o arquivo é um PDF, caso seja, ele não converte

      let arquivo = "";

      if (base64.type != "application/pdf") {
        const fotoConvertida = this.converteBase64ParaObjeto(
          base64,
          `aquivo-foto-${idTarget}`
        );

        if (fotoConvertida.size > this.limiteDeTamanhoArquivos) {
          this.msg(
            "ATENÇÃO",
            `O arquivo deve ser menor do que ${this.formatarBytes(
              this.limiteDeTamanhoArquivos
            )}.`,
            "danger"
          );
          return;
        }

        arquivo = fotoConvertida;
      } else {
        if (base64.size > this.limiteDeTamanhoArquivos) {
          this.msg(
            "ATENÇÃO",
            `O arquivo deve ser menor do que ${this.formatarBytes(
              this.limiteDeTamanhoArquivos
            )}.`,
            "danger"
          );
          return;
        }

        arquivo = base64;
      }

      // --------------------------------------------------------

      let nomeTratado = "invalido";

      if (arquivo.type == "image/png")
        nomeTratado = this.tratarNomeImg(`${arquivo.name}.png`, codBloco);

      if (arquivo.type == "image/jpeg")
        nomeTratado = this.tratarNomeImg(`${arquivo.name}.jpg`, codBloco);

      if (arquivo.type == "application/pdf")
        nomeTratado = this.tratarNomeImg(`${arquivo.name}.pdf`, codBloco);

      // console.log('arquivo',arquivo.target.id)

      if (nomeTratado == "invalido") {
        this.msg("ATENÇÃO", "Arquivo inválido", "danger");
        return;
      }

      const urlTemp = this.getUrlTemp(arquivo);

      listaImg.push({ nome: nomeTratado, url: urlTemp, progress: 0, apagarImagem: false });
      this.onUpload(arquivo, idTarget, nomeTratado, listaImgNome);

      const input = document.getElementById(`${idTarget}*`);
      input.value = arquivo.name;
    },

    converteBase64ParaObjeto(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },

    apagarImagem(arquivoNome, listaImg, formUrl, campoDB, idInput) {
      // Deleta da lista que vai pro html e deleta do firebase
      var index = 0;
      for (let i = 0; i < listaImg.length; i++) {
        if (listaImg[i] == arquivoNome) index = i;
      }

      listaImg.splice(index, 1);
      this.deleteFileFirebase(arquivoNome);

      //Deleta da lista de url de dentro do form
      const url = formUrl.filter((item) => item.match(arquivoNome));

      for (let i = 0; i < formUrl.length; i++) {
        if (formUrl[i] == url) index = i;
      }

      formUrl.splice(index, 1);

      // Atualiza no banco de dados
      const params = {
        id: this.form.id,
        //urlRg: String(formUrl)
        [campoDB]: String(formUrl),
      };
      this.atualizaListaUrl(params);

      const input = document.getElementById(idInput);
      input.value = null;
    },

    getUrlTemp(image) {
      // console.log(image)
      return URL.createObjectURL(image);
    },

    previwFoto(base64, idTarget, codBloco) {
      this.hasImage = true;
      this.image = base64;

      // Verifica se o arquivo é um PDF, caso seja, ele não converte

      let arquivo = "";

      if (base64.type != "application/pdf") {
        const fotoConvertida = this.converteBase64ParaObjeto(
          base64,
          `aquivo-foto-${idTarget}`
        );

        if (fotoConvertida.size > this.limiteDeTamanhoArquivos) {
          this.msg(
            "ATENÇÃO",
            `O arquivo deve ser menor do que ${this.formatarBytes(
              this.limiteDeTamanhoArquivos
            )}.`,
            "danger"
          );
          return;
        }

        arquivo = fotoConvertida;
      } else {
        if (base64.size > this.limiteDeTamanhoArquivos) {
          this.msg(
            "ATENÇÃO",
            `O arquivo deve ser menor do que ${this.formatarBytes(
              this.limiteDeTamanhoArquivos
            )}.`,
            "danger"
          );
          return;
        }

        arquivo = base64;
      }

      // --------------------------------------------------------

      // var tagId = e.target.id
      if (idTarget == "foto-perfil") {
        this.form.urlFotoPerfil = URL.createObjectURL(arquivo);

        let nomeTratado = "invalido";

        if (arquivo.type == "image/png")
          nomeTratado = this.tratarNomeImg(`${arquivo.name}.png`, codBloco);

        if (arquivo.type == "image/jpeg")
          nomeTratado = this.tratarNomeImg(`${arquivo.name}.jpg`, codBloco);

        if (arquivo.type == "application/pdf")
          nomeTratado = this.tratarNomeImg(`${arquivo.name}.pdf`, codBloco);

        if (nomeTratado == "invalido") {
          this.msg("ATENÇÃO", "Arquivo inválido", "danger");
          return;
        }

        this.onUpload(arquivo, idTarget, nomeTratado, null);

        const input = document.getElementById(`${idTarget}*`);
        input.value = arquivo.name;
      }
    },

    showModalDep() {
      this.editarDep = false;
      this.dependente = {};
      this.$refs["modal-dep"].show();
    },

    hideModalDep() {
      this.$refs["modal-dep"].hide();
    },

    saveDependente() {
      if (!this.dependente.nome) {
        this.msg("ATENÇÃO", "Informe o nome.", "warning");
        return;
      }

      if (!this.dependente.dataNasc) {
        this.msg("ATENÇÃO", "Informe a data de nascimento.", "warning");
        return;
      }

      if (!this.dependente.cpf) {
        this.msg("ATENÇÃO", "Informe o CPF.", "warning");
        return;
      }

      if (!this.dependente.tipo) {
        this.msg("ATENÇÃO", "Informe o tipo de dependente.", "warning");
        return;
      }

      this.$refs["modal-dep"].hide();

      if (this.editarDep == false) {
        this.form.dependentes.push(this.dependente);
      } else {
        this.form.dependentes.forEach((item, index) => {
          if (index == this.editarIndex) item = this.dependente;
        });
      }
    },

    editarDependente(data) {
      this.editarDep = true;

      this.dependente = data.item;
      this.editarIndex = data.index;
      this.$refs["modal-dep"].show();
    },

    apagarDependente(index) {
      this.form.dependentes.splice(index, 1);
      this.$refs["modal-dep"].hide();
    },

    async getDadosEmpresa() {
      // CT175+ Modificado para usar codUrl da solicitação (form.codUrl)
      // Isso garante que tenhamos acesso ao campo indCepPrecadastro da empresa
      const empresa = this.$route.query.emp || this.form.codUrl;

      try {
        const res = await api.get(
          `adesao/empresa/${empresa}/${this.form.atividadeProf}`
        );
        this.dadosEmpresa = res.data;
        this.bgColor = res.data.cor;
        this.logo = res.data.logoPath;
        this.escolaridades = this.dadosEmpresa.escolaridades;
        this.paises = this.dadosEmpresa.paises;
        this.bancos = [{ value: null, text: "" }, ...this.dadosEmpresa.bancos];
        this.tiposDependentes = this.dadosEmpresa.tiposDependentes;
        this.blocos = this.dadosEmpresa.blocos;
        this.labelDadosAdicionais = this.dadosEmpresa.labelDadosAdicionais;

        // CT175+ dadosEmpresa agora contém indCepPrecadastro (retornado automaticamente pelo select * na API)
        // console.log('Empresa carregada com indCepPrecadastro:', this.dadosEmpresa.indCepPrecadastro)

        if (!this.dadosEmpresa) this.$router.push("/adesao/erro");

      } catch (error) {
        console.error('Erro ao carregar dados da empresa:', error);
        if (!this.dadosEmpresa) this.$router.push("/adesao/erro");
      }
    },

    async getSolicitacao() {
      const key = this.$route.query.key;

      try {
        const res = await api.get("adesao/empresa/documentacao/" + key);

        // Status permitidos
        if (
          res.data.status != 1 &&
          res.data.status != 4 &&
          res.data.status != 5 &&
          res.data.status != 8 &&
          res.data.status != 28
        ) {
          this.$router.push("/adesao/erro");
        }

        //CT175 ATUALIZANDO PARA STATUS 5
        if(res.data.status === 28){
          await api.post("adesao/documentacao/atualizaStatus/" + key);
        }

        this.form = res.data;

        this.listaConhecimentosTecnicos = this.form.listaConhecimentosTecnicos;
        delete this.form.listaConhecimentosTecnicos;

        // this.imgRg = this.form.urlRg
        this.listaImgRg = this.form.urlRg.map((item) => {
          return {
            nome: item.split("%")[1].split("?")[0],
            url: item,
            progress: 0,
            apagarImagem: true
          };
        });

        this.listaCarteiraConselho = this.form.urlCarteiraConselho.map(
          (item) => {
            return {
              nome: item.split("%")[1].split("?")[0],
              url: item,
              progress: 0,
              apagarImagem: true
            };
          }
        );

        this.listaInscricaoPis = this.form.urlInscricaoPis.map((item) => {
          return {
            nome: item.split("%")[1].split("?")[0],
            url: item,
            progress: 0,
            apagarImagem: true
          };
        });

        this.listaTituloEleitor = this.form.urlTituloEleitor.map((item) => {
          return {
            nome: item.split("%")[1].split("?")[0],
            url: item,
            progress: 0,
            apagarImagem: true
          };
        });

        this.listaCCM = this.form.urlCCM.map((item) => {
          return {
            nome: item.split("%")[1].split("?")[0],
            url: item,
            progress: 0,
            apagarImagem: true
          };
        });

        this.listaEndereco = this.form.urlEndereco.map((item) => {
          return {
            nome: item.split("%")[1].split("?")[0],
            url: item,
            progress: 0,
            apagarImagem: true
          };
        });

        this.listaDadosBancarios = this.form.urlDadosBancarios.map((item) => {
          return {
            nome: item.split("%")[1].split("?")[0],
            url: item,
            progress: 0,
            apagarImagem: true
          };
        });

        this.listaDependentes = this.form.urlDependentes.map((item) => {
          return {
            nome: item.split("%")[1].split("?")[0],
            url: item,
            progress: 0,
            apagarImagem: true
          };
        });

        this.listaNegativaConselho = this.form.urlNegativaConselho.map(
          (item) => {
            return {
              nome: item.split("%")[1].split("?")[0],
              url: item,
              progress: 0,
              apagarImagem: true
            };
          }
        );

        this.listaDiploma = this.form.urlDiploma.map((item) => {
          return {
            nome: item.split("%")[1].split("?")[0],
            url: item,
            progress: 0,
            apagarImagem: true
          };
        });

        this.listaVacinacao = this.form.urlVacinacao.map((item) => {
          return {
            nome: item.split("%")[1].split("?")[0],
            url: item,
            progress: 0,
            apagarImagem: true
          };
        });

        this.listaCurriculo = this.form.urlCurriculo.map((item) => {
          return {
            nome: item.split("%")[1].split("?")[0],
            url: item,
            progress: 0,
            apagarImagem: true
          };
        });

        this.listaCriminais = this.form.urlAntCriminais.map((item) => {
          return {
            nome: item.split("%")[1].split("?")[0],
            url: item,
            progress: 0,
            apagarImagem: true
          };
        });

        this.listaAssinaturaCarimboCOREN =
          this.form.urlAssinaturaCarimboCoren.map((item) => {
            return {
              nome: item.split("%")[1].split("?")[0],
              url: item,
              progress: 0,
              apagarImagem: true
            };
          });

        this.listaBlocoVariavel_1500 = this.form.urlBlocoVariavel_1500.map(
          (item) => {
            return {
              nome: item.split("%")[1].split("?")[0],
              url: item,
              progress: 0,
              apagarImagem: true
            };
          }
        );

        this.listaBlocoVariavel_1510 = this.form.urlBlocoVariavel_1510.map(
          (item) => {
            return {
              nome: item.split("%")[1].split("?")[0],
              url: item,
              progress: 0,
              apagarImagem: true
            };
          }
        );

        this.listaBlocoVariavel_1520 = this.form.urlBlocoVariavel_1520.map(
          (item) => {
            return {
              nome: item.split("%")[1].split("?")[0],
              url: item,
              progress: 0,
              apagarImagem: true
            };
          }
        );

        this.listaBlocoVariavel_1530 = this.form.urlBlocoVariavel_1530.map(
          (item) => {
            return {
              nome: item.split("%")[1].split("?")[0],
              url: item,
              progress: 0,
              apagarImagem: true
            };
          }
        );

        this.listaBlocoVariavel_1540 = this.form.urlBlocoVariavel_1540.map(
          (item) => {
            return {
              nome: item.split("%")[1].split("?")[0],
              url: item,
              progress: 0,
              apagarImagem: true
            };
          }
        );

        // Verifica CEP para liberar alteração no endereço.
        // CT175+172 Validação de CEP null (quando indCepPrecadastro = 0 e vem da API externa)
        //----------------------------------------------
        if (this.form.cep) {
          const cep = this.form.cep.split("-");
          if (cep[1] == "000") this.enderecoEdit = false;
        }
        //----------------------------------------------

        if (!res.data.nacionalidade) this.form.nacionalidade = 105;

      } catch (error) {
        this.$router.push("/adesao/erro");
      }
    },

    async getBlocosReprovados() {
      const key = this.$route.query.key;

      try {
        const res = await api.get(
          "adesao/documentacao/blocos-reprovados/" + key
        );
        // console.log('blocoooooo',res.data)
        this.blocos = res.data;

        // console.log('this.blocos.create', this.blocos)
      } catch (error) {
        // this.msg("ATENÇÃO", 'Falha ao buscar blocos reprovados.', "danger");
      }
    },

    async salvar(acao) {
      if (this.form.urlFotoPerfil?.match("blob")) {
        if (acao === 'enviar') this.msg("ATENÇÃO", "Aguarde o upload da Foto de perfil...", "warning");
        return;
      }

      if (this.form.urlRg.length != this.listaImgRg.length) {
        if (acao === 'enviar') this.msg("ATENÇÃO", "Aguarde o upload do RG...", "warning");
        return;
      }

      if (
        this.form.urlCarteiraConselho.length !=
        this.listaCarteiraConselho.length
      ) {
        if (acao === 'enviar') this.msg(
          "ATENÇÃO",
          "Aguarde o upload da Carteira de conselho...",
          "warning"
        );
        return;
      }

      if (this.form.urlInscricaoPis.length != this.listaInscricaoPis.length) {
        if (acao === 'enviar') this.msg("ATENÇÃO", "Aguarde o upload da Inscrição PIS...", "warning");
        return;
      }

      if (this.form.urlTituloEleitor.length != this.listaTituloEleitor.length) {
        if (acao === 'enviar') this.msg(
          "ATENÇÃO",
          "Aguarde o upload do Título de eleitor...",
          "warning"
        );
        return;
      }

      if (this.form.urlCCM.length != this.listaCCM.length) {
        if (acao === 'enviar') this.msg("ATENÇÃO", "Aguarde o upload do CCM...", "warning");
        return;
      }

      if (this.form.urlEndereco.length != this.listaEndereco.length) {
        if (acao === 'enviar') this.msg(
          "ATENÇÃO",
          "Aguarde o upload do Comprovante de Endereço...",
          "warning"
        );
        return;
      }

      if (
        this.form.urlDadosBancarios.length != this.listaDadosBancarios.length
      ) {
        if (acao === 'enviar') this.msg(
          "ATENÇÃO",
          "Aguarde o upload do Dados Bancários...",
          "warning"
        );
        return;
      }

      if (
        this.form.urlDependentes.length != this.listaDependentes.length
      ) {
        if (acao === 'enviar') this.msg(
          "ATENÇÃO",
          "Aguarde o upload dos documentos de Dependentes...",
          "warning"
        );
        return;
      }

      if (
        this.form.urlNegativaConselho.length !=
        this.listaNegativaConselho.length
      ) {
        if (acao === 'enviar') this.msg(
          "ATENÇÃO",
          "Aguarde o upload da Negativa do Conselho...",
          "warning"
        );
        return;
      }

      if (this.form.urlDiploma.length != this.listaDiploma.length) {
        if (acao === 'enviar') this.msg("ATENÇÃO", "Aguarde o upload do Diploma...", "warning");
        return;
      }

      if (this.form.urlVacinacao.length != this.listaVacinacao.length) {
        if (acao === 'enviar') this.msg("ATENÇÃO", "Aguarde o upload da Vacinação...", "warning");
        return;
      }

      if (this.form.urlCurriculo.length != this.listaCurriculo.length) {
        if (acao === 'enviar') this.msg("ATENÇÃO", "Aguarde o upload do Currículo...", "warning");
        return;
      }

      if (this.form.urlAntCriminais.length != this.listaCriminais.length) {
        if (acao === 'enviar') this.msg(
          "ATENÇÃO",
          "Aguarde o upload do Antecedentes Criminais...",
          "warning"
        );
        return;
      }

      if (
        this.form.urlAssinaturaCarimboCoren.length !=
        this.listaAssinaturaCarimboCOREN.length
      ) {
        if (acao === 'enviar') this.msg(
          "ATENÇÃO",
          "Aguarde o upload da Assinatura e Carimbo do COREN...",
          "warning"
        );
        return;
      }

      if (
        this.form.urlBlocoVariavel_1500.length !=
        this.listaBlocoVariavel_1500.length
      ) {
        if (acao === 'enviar') this.msg(
          "ATENÇÃO",
          "Aguarde o upload do Bloco Variavel 1500...",
          "warning"
        );
        return;
      }

      if (
        this.form.urlBlocoVariavel_1510.length !=
        this.listaBlocoVariavel_1510.length
      ) {
        if (acao === 'enviar') this.msg(
          "ATENÇÃO",
          "Aguarde o upload do Bloco Variavel 1510...",
          "warning"
        );
        return;
      }

      if (
        this.form.urlBlocoVariavel_1520.length !=
        this.listaBlocoVariavel_1520.length
      ) {
        if (acao === 'enviar') this.msg(
          "ATENÇÃO",
          "Aguarde o upload do Bloco Variavel 1520...",
          "warning"
        );
        return;
      }

      if (
        this.form.urlBlocoVariavel_1530.length !=
        this.listaBlocoVariavel_1530.length
      ) {
        if (acao === 'enviar') this.msg(
          "ATENÇÃO",
          "Aguarde o upload do Bloco Variavel 1530...",
          "warning"
        );
        return;
      }

      if (
        this.form.urlBlocoVariavel_1540.length !=
        this.listaBlocoVariavel_1540.length
      ) {
        if (acao === 'enviar') this.msg(
          "ATENÇÃO",
          "Aguarde o upload do Bloco Variavel 1540...",
          "warning"
        );
        return;
      }

      // CT175+ Validação condicional de endereço
      // Se CEP veio do pré-cadastro (indCepPrecadastro = 1), já foi validado lá
      // Se CEP é da documentação (indCepPrecadastro = 0 ou null), valida aqui
      if (acao === 'enviar') {

        // Só valida endereço completo se NÃO veio do pré-cadastro
        if (!this.dadosEmpresa || this.dadosEmpresa.indCepPrecadastro !== 1) {

          if (!this.form.cep) {
            this.msg("ATENÇÃO", "Informe um CEP válido.", "warning");
            return;
          }

          if (!this.form.cidade) {
            this.msg("ATENÇÃO", "Informe a cidade.", "warning");
            return;
          }

          if (!this.form.uf) {
            this.msg("ATENÇÃO", "Informe o estado (UF).", "warning");
            return;
          }

          if (!this.form.bairro) {
            this.msg("ATENÇÃO", "Informe o bairro.", "warning");
            return;
          }

          if (!this.form.endereco) {
            this.msg("ATENÇÃO", "Informe o logradouro (endereço).", "warning");
            return;
          }
        }

        // Número do endereço sempre obrigatório (tanto pré-cadastro quanto documentação)
        if (!this.form.numEndereco) {
          this.msg("ATENÇÃO", "Informe o número do endereço.", "warning");
          return;
        }
      }

      // Criando clone do this.form para não alterar o original e acionar o watch, disparando múltiplas requisições à API.
      const formEditavel = { ...this.form };

      this.botaoVisivel = false;

      formEditavel.idEmpresa = this.dadosEmpresa.id;
      formEditavel.empresa = this.dadosEmpresa.nomeEmpresa;
      formEditavel.blocos = this.blocos;
      formEditavel.indPixObrigatorio = this.dadosEmpresa.indPixObrigatorio;

      formEditavel.nome = formEditavel.nome.toUpperCase();
      if (formEditavel.nomeMae)
        formEditavel.nomeMae = formEditavel.nomeMae.toUpperCase();
      if (formEditavel.nomePai)
        formEditavel.nomePai = formEditavel.nomePai.toUpperCase();
      if (formEditavel.nomeConjuge)
        formEditavel.nomeConjuge = formEditavel.nomeConjuge.toUpperCase();

      if (formEditavel.status != 8) formEditavel.status = 5;
      if (acao == "enviar") formEditavel.status = 6;

      if (this.ref)
        document.getElementById(this.ref).style.backgroundColor = "#FFFFFF";

      api
        .post("adesao/empresa/documentacao", formEditavel)
        .then(() => {

          if (acao === 'enviar') this.msg("SUCESSO", "DOCUMENTAÇÃO ENVIADA", "success", 5000);

          this.botaoVisivel = true;
          if (acao === 'enviar') this.deslogarFirebase();

          if (formEditavel.status == 5 || formEditavel.status == 8)
            localStorage.setItem("idMsg", 13);
          if (formEditavel.status == 6) localStorage.setItem("idMsg", 12);

          localStorage.setItem("nome", formEditavel.nome);
          localStorage.setItem(
            "dadosEmpresa",
            JSON.stringify(this.dadosEmpresa)
          );

          if (acao === 'enviar') {

            if (this.dadosEmpresa.indFeedback === 'sim') this.$refs["modal-avaliacao"].show();
            else this.$router.push("/msg")

          }
        })
        .catch((err) => {
          console.error('[SALVAR] ✗ ERRO ao salvar!');
          console.error('[SALVAR] Erro completo:', err);
          console.error('[SALVAR] Status do erro:', err?.response?.status);
          console.error('[SALVAR] Mensagem do erro:', err?.response?.data);
          console.error('[SALVAR] Config da requisição:', err?.config);

          this.botaoVisivel = true;

          if (err.response.status == 500) {
            console.error('[SALVAR] Erro 500 - Erro interno do servidor');
            this.msg("ATENÇÃO", err.response.data, "danger");
            return;
          } else {
            console.error('[SALVAR] Erro validação - Status:', err.response.status);
            const erro = err.response.data.split("|");
            this.ref = erro[1];
            this.msg("ATENÇÃO", erro[0], "warning");
          }

          const el = this.$refs[this.ref];
          el.scrollIntoView({ behavior: "smooth" });
          document.getElementById(this.ref).style.backgroundColor = "#F6DADD";
        });
    },

    async atualizaListaUrl(urls) {
      try {
        await api.put("adesao/empresa/documentacao/urls", urls);
      } catch (error) {
        this.msg("ATENÇÃO", error.response.data, "danger");
      }
    },

    tratarNomeImg(nomeImg, codBloco) {
      const nome = nomeImg.split(".");
      const agora = Math.floor(Date.now());
      const ext = nome[nome.length - 1].toLowerCase();

      if (ext == "jpg" || ext == "jpeg" || ext == "png" || ext == "pdf") {
        const idEmpresaFormatado = String(this.dadosEmpresa.id).padStart(
          3,
          "0"
        );
        const cpfSemMascara = this.form.cpf.replace(/\D/g, "");

        return `${idEmpresaFormatado}_${this.form.id}_${cpfSemMascara}_${codBloco}_${agora}.${ext}`;
      } else return "invalido";
    },

    async onUpload(file, idTag, nomeArquivoTratado, listaImg) {

      if (!file) return;
    
      const formFieldMap = {

        'foto-perfil': 'urlFotoPerfil',
        'rg': 'urlRg',
        'carteira-conselho': 'urlCarteiraConselho',
        'inscricao-pis': 'urlInscricaoPis',
        'titulo-eleitor': 'urlTituloEleitor',
        'ccm': 'urlCCM',
        'endereco': 'urlEndereco',
        'dados-bancarios': 'urlDadosBancarios',
        'dependentes-img': 'urlDependentes',
        'negativa-conselho': 'urlNegativaConselho',
        'diploma': 'urlDiploma',
        'vacinacao': 'urlVacinacao',
        'curriculo': 'urlCurriculo',
        'ant-criminais': 'urlAntCriminais',
        'AssinaturaCarimboCOREN': 'urlAssinaturaCarimboCoren',
        'blocoVariavel_1500': 'urlBlocoVariavel_1500',
        'blocoVariavel_1510': 'urlBlocoVariavel_1510',
        'blocoVariavel_1520': 'urlBlocoVariavel_1520',
        'blocoVariavel_1530': 'urlBlocoVariavel_1530',
        'blocoVariavel_1540': 'urlBlocoVariavel_1540',
        
      };
    
      try {

        const storageRef = firebase.storage().ref();
        const metadata = { accept: [".jpg", ".jpeg", ".pdf", ".png"] };
    
        let pathBase = idTag === "foto-perfil"
        ? process.env.VUE_APP_FIREBASE_FOTOPERFIL
        : process.env.VUE_APP_FIREBASE_DOCUMENTOS;
    
        const fileRef = storageRef.child(`${pathBase}/${nomeArquivoTratado}`);
        const uploadTask = fileRef.put(file, metadata);
    
        const timeout = setTimeout(() => {

          uploadTask.cancel();
          if (listaImg && this[listaImg] && this[listaImg].length > 0) {

            const index = this[listaImg].length - 1;
            this[listaImg].splice(index, 1)

          }

          document.getElementById(`${idTag}*`).value = null;

          this.msg('ERRO NO UPLOAD', 'O envio foi cancelado por exceder o tempo limite de carregamento. Verifique sua conexão com a internet e tente novamente, se o problema persistir contate o administrativo.', 'danger');

        }, 10000);
    
        uploadTask.on(

          'state_changed',
    
          (snapshot) => {

            if (listaImg && this[listaImg] && this[listaImg].length > 0) {

              const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              const index = this[listaImg].length - 1;
              this.$set(this[listaImg][index], 'progress', Math.floor(progress));

            }

          },
    
          (error) => {

            clearTimeout(timeout); // Limpa o timeout caso o erro venha antes
            console.error('Erro no upload:', error);

          },
    
          async () => {

            clearTimeout(timeout); // Limpa o timeout ao finalizar com sucesso
    
            const urlFirebase = await uploadTask.snapshot.ref.getDownloadURL();
            const field = formFieldMap[idTag];
    
            if (field) {

              if (idTag === 'foto-perfil') this.form[field] = urlFirebase;
              else {

                this.form[field].push(urlFirebase);
                if (listaImg && this[listaImg] && this[listaImg].length > 0) {

                  const index = this[listaImg].length - 1;
                  this.$set(this[listaImg][index], 'progress', 0);
                  this.$set(this[listaImg][index], 'apagarImagem', true);

                }

              }

            }

          }

        )
    
      } catch (error) {

        console.log("ERR ===>", error);

      }

    },
    
    async onDeleteImage() {
      if (this.nomeFoto.length == 0) return;

      try {
        this.nomeFoto.forEach((item) => {
          const storageRef = firebase.storage().ref();
          var desertRef = storageRef.child(`fotos_perfil/${item}`);
          desertRef.delete();
        });
      } catch (error) {
        console.log("ERR ===", error);
        //alert("Image uploading failed!")
      }
    },

    async deleteFileFirebase(arquivoNome) {
      if (!arquivoNome) return;

      try {
        const storageRef = firebase.storage().ref();
        var desertRef = storageRef.child(`fotos_perfil/${arquivoNome}`);
        desertRef.delete();
      } catch (error) {
        console.log("ERR ===", error);
        //alert("Image uploading failed!")
      }
    },

    verificaHifen() {
      const regex = /-/;
      const contemHifen = regex.test(this.form.rg);

      if (contemHifen)
        return "return event.charCode == 46 || event.charCode >= 48 && event.charCode <= 57 || event.charCode >= 65 && event.charCode <= 90 || event.charCode >= 97 && event.charCode <= 122";
      else
        return "return event.charCode == 45 || event.charCode == 46 || event.charCode >= 48 && event.charCode <= 57";
    },

    abrirSeletorDeFotos(id) {
      document.getElementById(id).click();
    },

    async getMunicipiosEUFs() {
      api
        .get("adesao/documentacao/municipios")
        .then((res) => {
          this.ufs = res.data.ufs;
          this.municipios = res.data.municipios;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    carregarMunicipios() {
      this.municipiosPorUF = this.municipios.filter(
        (item) => item.uf === this.form.ufNascimento
      );

      // console.log(this.municipios)
    },

    registrarAvaliacao() {
      const body = {
        idSolicitacao: this.form.id,
        avaliacao: this.avaliacao.rating,
        comentario: this.avaliacao.comentario,
      };

      api
        .post("adesao/documentacao/avaliacao-estrelas", body)
        .then(() => {
          this.$refs["modal-avaliacao"].hide();
          this.$router.push("/msg");
        })
        .catch((err) => {
          this.msg("ATENÇÃO", err.response.data, "danger", 3000);
        });
    },

    formatarBytes(bytes) {
      if (bytes === 0) return "0 Bytes";

      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
    },

    sairDaPagina(acao) {

      if (acao === 'desistir') localStorage.setItem("idMsg", 16);
      else if (acao === 'continuarDepois') localStorage.setItem("idMsg", 17);

      localStorage.setItem("nome", this.form.nome || '');
      localStorage.setItem("dadosEmpresa", JSON.stringify(this.dadosEmpresa));

      // ----------------------------------------------------------------------

      if (acao === 'desistir' && this.dadosEmpresa.indFeedback === 'sim') this.$refs["modal-avaliacao"].show();
      else if (acao === 'continuarDepois' || (acao === 'desistir' && this.dadosEmpresa.indFeedback !== 'sim')) this.$router.push("/msg")

    },

    // CT175+ Função para buscar o CEP via BrasilAPI
    // Na documentação, CEP é SEMPRE editável (independente de indCepPrecadastro)
    buscarCep() {

      // Limpa campos antes de buscar
      this.form.endereco = null
      this.form.bairro = null
      this.form.cidade = null
      this.form.uf = null

      if (this.form.cep.length == 9) {
        // Remove hífen para a BrasilAPI (aceita apenas números)
        const cepNumeros = this.form.cep.replace('-', '')
        const cepFormatado = this.form.cep

        axios
          .get(`https://brasilapi.com.br/api/cep/v1/${cepNumeros}`, { timeout: 3000 })
          .then((res) => {
            console.log(res.data);

            const dadosCep = res.data;
            this.form.endereco = dadosCep.street;
            this.form.bairro = dadosCep.neighborhood;
            this.form.cidade = dadosCep.city;
            this.form.uf = dadosCep.state;
          })
          .catch((err) => {
            if (err.code === 'ECONNABORTED') {
              this.msg("Tempo esgotado", `Não foi possível consultar o CEP ${cepFormatado}. Tente novamente.`, "warning");
            } else {
              this.msg("CEP não encontrado", `O CEP ${cepFormatado} não foi encontrado. Verifique e tente novamente.`, "danger");
            }
          });
      }

    },


  },

  computed: {
    cssVars() {
      return {
        "--bg-color": this.bgColor,
        "--height": this.height + "px",
      };
    },

    // ...mapState( state => state.firebase.user ),
  },
};
